@if (typeDesignationData | async; as typeDesignationData) {
    <sew-tab-bar hierarchy="sub">
        <sew-tab-bar-item
            [name]="'SPARE_PARTS_LIST.TAB.SPARE_PARTS_LISTS' | translate"
            selected="true"
            (click)="searchLimitNotificationService.setVisibility(false)"
        >
            <ecs-spare-part-lists-table
                [items]="typeDesignationData"
                [columns]="['documentNumber', 'groupTitle', 'url']"
            >
            </ecs-spare-part-lists-table>
        </sew-tab-bar-item>
        <sew-tab-bar-item
            [name]="'SPARE_PARTS_LIST.TAB.MATERIAL' | translate"
            (click)="searchLimitNotificationService.setVisibility(true)"
        >
            <ecs-spare-parts-result [searchResult]="freeTextData"></ecs-spare-parts-result>
        </sew-tab-bar-item>
    </sew-tab-bar>
} @else {
    <ecs-part-table-skeleton [showGroupHeader]="false" [rowCount]="9"></ecs-part-table-skeleton>
}
